angular.module('resourceCenterMaterialModule').directive('initTopButtons', [
    'mrApiService',
    'modalDialog',
    'trsspliceString',
    'editingCenterService',
    'mrService',
    function(mrApiService, modalDialog, trsspliceString, editingCenterService, mrService) {
        return {
            scope: true, // 继承作用域
            restrict: 'EA',
            templateUrl: './resourceCenter/materialResource/directive/initButtons/initTopButtons.html',
            replace: true,
            link: function($scope) {
                initStatus();
                initData();

                /**
                 * [initStatus description]初始化状态
                 * @return {[type]} [description]
                 */
                function initStatus() {
                
                    // 素材类型
                    $scope.resourceType = {
                        '0': '图片',
                        '1': '音频',
                        '2': '视频',
                        '3': '文字',
                    };
                    // 上传时候的素材类型
                    $scope.resourceUpload = {
                        '0': 'showUpload',
                        '1': 'showUpload',
                        '2': 'showUpload',
                    };
                    $scope.checkList = {}; // 存放的用来判断是否显示按钮
                    $scope.relationid = ''; // 存放处理之后的id参数
                    $scope.canOprate = true;
                }

                /**
                 * [initData description]初始化数据
                 *
                 * @return  {[type]}  [return description]
                 */
                function initData() {
                    initBtnRights();
                }

                /**
                 * [initBtnRights description] 初始化按钮权限
                 * @return  {[type]}  [return description]
                 */
                function initBtnRights() {
                    getBtnRights();
                }

                /**
                 * [getBtnRights 获取按钮权限]
                 *
                 * @return  {[type]}  [return description]
                 */
                function getBtnRights(){
                    mrService.getBtnRights($scope.basicalStatus.commonParams.mrType, $scope.basicalStatus.commonParams.mainResourceType).then(function(data){
                        $scope.basicalStatus.checkList = $scope.checkList = data;
                    });
                }


                $scope.hasRights = function(type){
                    let mrtype = $scope.basicalStatus.commonParams.mrType;
                    if (mrtype === 'personal') {
                        return $scope.checkList.chakan;
                    } else {
                        if (mrtype === 'share' || mrtype === 'meizi') {
                            return 'chakan,upload,edit,delete'.indexOf(type) !== -1 && $scope.checkList[type];
                        } else if (mrtype === 'edited'){
                            return 'chakan,upload,edit,delete,uploadmeizi'.indexOf(type) !== -1 && $scope.checkList[type];
                        } else {
                            return false;
                        }
                    }
                }; 

                /**
                 * [trial description]上传操作
                 * @return {[type]} [description]
                 */
                $scope.upload = function() {
                    $scope.basicalStatus[$scope.resourceUpload[$scope.basicalStatus.buttonsNeedParams.resourceType]] = true;
                };

                /**
                 * [createMateralFolder description]新建文件夹
                 * @return {[type]} [description]
                 */
                $scope.createMateralFolder = function() {
                    if (!checkCanOper()){
                        modalDialog.alertType('', '无法在此处执行此操作', 'warning');
                        return;
                    }
                    mrService.newFile($scope.basicalStatus.commonParams).then((res) => {
                        mrApiService.createMateralFolder(angular.extend({ fileName: res }, $scope.basicalStatus.commonParams)).then((data) => {
                            if (data.code === '200') {
                                modalDialog.alertType('新建成功', '', 'success', false);
                                $scope.requestData();
                            } else {
                                modalDialog.alertType('新建失败', '', 'error', false);
                            }
                        });
                    });
                };

                /**
                 * [moveToSharedMaterial description]上传至共享素材
                 * @return {[type]}      [description]
                 */
                $scope.moveToSharedMaterial = function() {
                    modalDialog.confirmModal('提示', '确定要上传到共享素材吗?', function() {
                        dealRelationId();
                        if (!$scope.canOprate) {
                            modalDialog.alertType('您所选的素材中包含未处理成功的素材，无法执行此操作', '', 'error', false);
                            $scope.canOprate = true;
                            return;
                        }
                        mrApiService
                            .moveToSharedMaterial(angular.extend({ relationIds: $scope.relationid }, $scope.basicalStatus.commonParams))
                            .then((data) => {
                                if (data.code === '200') {
                                    modalDialog.alertType('上传至共享素材成功', '', 'success', false);
                                    $scope.requestData();
                                } else {
                                    modalDialog.alertType('上传至共享素材失败', '', 'error', false);
                                }
                            });
                    });
                };

                /**
                 * [checkCanOper AI标签页、以图搜图页不允许操作]
                 *
                 * @return  {[type]}  [return description]
                 */
                function checkCanOper() {
                    if ($scope.basicalStatus.isLabelMaterial || $scope.basicalStatus.isPicSearch || $scope.basicalStatus.isAI) {
                        return false;
                    }
                    return true;
                }

                /**
                 * [moveToMaterialLibary description]上传至媒资库
                 *
                 * @return  {[type]}  [return description]
                 */
                $scope.moveToMaterialLibary = function() {
                    modalDialog.confirmModal('提示', '确定要上传到媒资库吗?', function() {
                        dealRelationId();
                        if (!$scope.canOprate) {
                            modalDialog.alertType('您所选的素材中包含未处理成功的素材，无法执行此操作', '', 'error', false);
                            $scope.canOprate = true;
                            return false;
                        }
                        mrApiService
                            .moveToMaterialLibary(angular.extend({ relationIds: $scope.relationid }, $scope.basicalStatus.commonParams))
                            .then((data) => {
                                if (data.code === '200') {
                                    modalDialog.alertType('上传至媒资库成功', '', 'success', false);
                                    $scope.requestData();
                                } else {
                                    modalDialog.alertType('上传至媒资库失败', '', 'error', false);
                                }
                            });
                    });
                };

                /**
                 * [moveToPersonalMaterial description:取至个人素材]
                 * @return  {[type]}         [return description]
                 */
                $scope.moveToPersonalMaterial = function() {
                    modalDialog.confirmModal('提示', '确定要取至个人素材吗?', function() {
                        dealRelationId();
                        if (!$scope.canOprate) {
                            modalDialog.alertType('您所选的素材中包含未处理成功的素材，无法执行此操作', '', 'error', false);
                            $scope.canOprate = true;
                            return;
                        }
                        mrApiService
                            .moveToPersonalMaterial(angular.extend({ relationIds: $scope.relationid }, $scope.basicalStatus.commonParams))
                            .then((data) => {
                                if (data.code === '200') {
                                    modalDialog.alertType('取至个人素材成功', '', 'success', false);
                                    $scope.requestData();
                                } else {
                                    modalDialog.alertType('取至个人素材失败', '', 'success', false);
                                }
                            });
                    });
                };

                /**
                 * [takeDoc description]取稿操作
                 *
                 * @return  {[type]}  [return description]
                 */
                $scope.takeDoc = function() {
                    for (var i = 0; i < $scope.selectedArray.length; i++) {
                        if ($scope.selectedArray[0].relationtype === 0) {
                            modalDialog.alertType('所选素材包含文件夹，不能取稿', '', 'error', false);
                            return;
                        }
                    }
                    if ($scope.selectedArray[0].relationtype === 0) {
                        modalDialog.alertType('文件夹不能取稿', '', 'error', false);
                    } else {
                        dealRelationId();
                        if (!$scope.canOprate) {
                            modalDialog.alertType('您所选的素材中包含未处理成功的素材，无法执行此操作', '', 'error', false);
                            $scope.canOprate = true;
                            return;
                        }
                        mrService.takeDoc($scope.relationid, $scope.basicalStatus.commonParams);
                    }
                };

                /**
                 * [hasShowUploadBtn 是否显示上传按钮]
                 *
                 * @return  {[type]}  [return description]
                 */
                $scope.hasShowUploadBtn = function(){
                    return !$scope.basicalStatus.isAI && ($scope.checkList.upload || ($scope.basicalStatus.ispersonalmaterial && $scope.basicalStatus.commonParams.mainResourceType!='3'));
                };

                /**
                 * [moveMaterialToFolder description]移动到文件夹内
                 * @return  {[type]}  [return description]
                 */
                $scope.moveMaterialToFolder = function() {
                    try {
                        let errorMsg = '';
                        let canOper = true;
                        $scope.selectedArray.forEach((item) => {
                            if (item.relationtype === 0) {
                                canOper = false;
                                errorMsg = '文件夹不能移动';
                            }
                        });
                        if (!canOper) {
                            modalDialog.alertType(errorMsg, '', 'error', false);
                            return;
                        }
                        mrApiService.getAllFolders(angular.extend({}, $scope.basicalStatus.commonParams)).then((treeData) => {
                            editingCenterService.modalWithTree(treeData.datas).then((data) => {
                                let params = {
                                    fileId: data.relationid,
                                    relationIds: trsspliceString.spliceString($scope.selectedArray, 'relationid', ','),
                                };
                                mrApiService.moveMaterialToFolder(angular.extend(params, $scope.basicalStatus.commonParams)).then((data) => {
                                    // 请帮助我刷新一下列表
                                    modalDialog.alertType('移动成功', '', 'success', false);
                                    $scope.basicalStatus.indexParams.pageNum = $scope.basicalStatus.searchParams.pageNum = $scope.page.CURRPAGE = $scope.basicalStatus.copyCurrPage = 1;
                                    $scope.requestData();
                                });
                            });
                        });
                    } catch (e) {
                        modalDialog.alertType(e, '', 'error', false);
                    }
                };

                /**
                 * [dealRelationId description]处理选中的数据的relationId参数
                 *
                 * @return  {[type]}  [return description]
                 */
                function dealRelationId() {
                    var relationid = '';
                    let allowStatus = $scope.basicalStatus.materialStatus.success.value + ',' + $scope.basicalStatus.materialStatus.auditFail.value + ',' + $scope.basicalStatus.materialStatus.auditing.value;
                    $scope.selectedArray.forEach((item) => {
                        if (allowStatus.indexOf(item.resourcestatus) < 0) {
                            $scope.canOprate = false;
                        }
                        relationid += `${item.relationid},`;
                    });
                    $scope.relationid = relationid = relationid.slice(0, -1);
                }

                /**
                 * [deleteMaterial description]删除素材操作
                 *
                 * @return  {[type]}  [return description]
                 */
                $scope.deleteMaterial = function() {
                    let message;
                    dealRelationId();
                    $scope.selectedArray.forEach((item) => {
                        if (item.relationtype === 0) {
                            message = '如果删除文件夹，文件夹内的素材会被全部删除，确认删除吗？';
                        } else {
                            message = '确定要删除吗？';
                        }
                    });
                    modalDialog.confirmModal('提示', message, function() {
                        mrApiService
                            .deleteMaterial(angular.extend({ relationIds: $scope.relationid }, $scope.basicalStatus.commonParams))
                            .then((data) => {
                                if (data.code === '200') {
                                    modalDialog.alertType('删除成功', '', 'success', false);
                                    $scope.requestData();
                                }
                            });
                    });
                };

                /**
                 * [preStatusCache 缓存切换智能分类前的状态]
                 *
                 * @return  {[type]}  [return description]
                 */
                function preStatusCache(){
                    if ($scope.basicalStatus.isInFolder) {
                        $scope.basicalStatus.preStatus = 'inFolder';
                    }
                    if ($scope.basicalStatus.isPicSearch) {
                        $scope.basicalStatus.preStatus = 'picSearch';
                    }
                }

                /**
                 * [backFromAI 从智能分类标签切换回最近添加时恢复之前状态]
                 *
                 * @return  {[type]}  [return description]
                 */
                function backFromAI() {
                    if ($scope.basicalStatus.preStatus === 'inFolder') {
                        $scope.basicalStatus.isInFolder = true;
                    }
                    if ($scope.basicalStatus.preStatus === 'picSearch') {
                        $scope.basicalStatus.isPicSearch = true;
                    }
                }

                /**
                 * [switchAI description]
                 *
                 * @param   {[type]}  bool  [bool 是否切换到AI分类]
                 *
                 * @return  {[type]}        [return description]
                 */
                $scope.switchAI = function(bool) {
                    $scope.basicalStatus.isAI = bool;
                    if (bool) {
                        preStatusCache();
                        $scope.basicalStatus.isInFolder = false;
                        $scope.basicalStatus.isPicSearch = false;
                    } else {
                        // $scope.page.CURRPAGE = 1;
                        backFromAI();
                        $scope.basicalStatus.isLabelMaterial = false;
                        $scope.basicalStatus.searchParams.mark = '';
                        $scope.page.CURRPAGE = $scope.basicalStatus.searchParams.pageNum;
                    }
                    $scope.requestData();
                };

                $scope.checkMaterial = function() {
                    dealRelationId();
                    $scope.selectedArray.forEach((item) => {
                        if (item.relationtype === 0) {
                            modalDialog.alertType('提示', '所选项含有文件夹，无法智能机审');
                            return;
                        } 
                    });
                    mrApiService
                        .requestCensor(angular.extend({ relationId: $scope.relationid }, $scope.basicalStatus.commonParams))
                        .then((data) => {
                            if (data.code === '200') {
                                modalDialog.alertType('智能机审开始进行', '', 'success', false);
                                $scope.requestData();
                            } else {
                                modalDialog.alertType('智能机审提交异常', '', 'error', false);
                                $scope.requestData();
                            }
                        });
                };
            },
        };
    },
]);
